import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LayersIcon from '@mui/icons-material/Layers';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getAllVerifyResponse, getUserInfo} from "../store/logIn";


function MainListItems(props){
    const navigate = useNavigate()
    const {t, i18n} = useTranslation()
    const [is_main, setIsMain] = useState(false)

    useEffect(()=>{
        props.getUserInfo()
    }, [])

    useEffect(()=>{
        setIsMain(props.user.is_main)
    }, [props])

    const [isHome, setIsHome] = useState(false)
    const [documents, setDocuments] = useState(false)
    const [reports, setReports] = useState(false)
    const [problems, setProblems] = useState(false)
    const [workers, setWorkers] = useState(false)

    function changeValues(val){
        switch (val){
            case 1:
                navigate('/dashboard/')
                break;
            case 2:
                navigate('/documents/')
                break;
            case 3:
                navigate('/reports/')
                break;
            case 4:
                navigate('/problems/')
                break;
            case 5:
                navigate('/workers/')
                break;
            default:
                return false
        }
    }

    useEffect(()=>{
        if(window.location.pathname === '/dashboard/'){
            setIsHome(true)
            setDocuments(false)
            setProblems(false)
            setReports(false)
            setWorkers(false)
        }else if(window.location.pathname === '/documents/'){
            setDocuments(true)
            setIsHome(false)
            setProblems(false)
            setReports(false)
            setWorkers(false)
        }else if(window.location.pathname === '/problems/'){
            setProblems(true)
            setDocuments(false)
            setIsHome(false)
            setReports(false)
            setWorkers(false)
        } else if(window.location.pathname === '/reports/'){
            setReports(true)
            setDocuments(false)
            setIsHome(false)
            setProblems(false)
            setWorkers(false)
        }
        else if(window.location.pathname === '/workers/'){
            setWorkers(true)
            setDocuments(false)
            setIsHome(false)
            setProblems(false)
            setReports(false)
        }
    }, [])


    if(is_main){
        return <div className={'menu'}>
            <ListItemButton className={isHome ? 'active' : ''}  onClick={()=>changeValues(1)} >
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary={t('home')}/>
            </ListItemButton>
        </div>
    }

    return <div className={'menu'}>
        <ListItemButton className={isHome ? 'active' : ''}  onClick={()=>changeValues(1)} >
            <ListItemIcon>
                <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary={t('home')}/>
        </ListItemButton>
        <ListItemButton className={documents ? 'active' : ''}  onClick={()=>changeValues(2)} >
            <ListItemIcon>
                <LayersIcon />
            </ListItemIcon>
            <ListItemText primary={t('documents')}/>
        </ListItemButton>
        <ListItemButton className={problems ? 'active' : ''}  onClick={()=>changeValues(4)}>
            <ListItemIcon>
                <SyncProblemIcon />
            </ListItemIcon>
            <ListItemText primary={t('problems')}/>
        </ListItemButton>
        <ListItemButton className={workers ? 'active' : ''}  onClick={()=>changeValues(5)}>
            <ListItemIcon>
                <FolderSharedIcon />
            </ListItemIcon>
            <ListItemText primary={t('workers')}/>
        </ListItemButton>
        <ListItemButton className={reports ? 'active' : ''}  onClick={()=>changeValues(3)}>
            <ListItemIcon>
                <SummarizeIcon />
            </ListItemIcon>
            <ListItemText primary={t('reports')}/>
        </ListItemButton>
    </div>
}

export default connect(props=>props.login, {getAllVerifyResponse, getUserInfo})(MainListItems)
